export const blogList = [
  {
    id: 1,
    title: 'Javascript ',
    category: 'Javascript',
    subCategory: ['frontend', 'ui/ux', 'design'],
    description:
      "JavaScript is a lightweight, interpreted programming language. It is designed for creating network-centric applications. It is complimentary to and integrated with Java. JavaScript is very easy to implement because it is integrated with HTML. It is open and cross-platform.Javascript is a MUST for students and working professionals to become a great Software Engineer specially when they are working in Web Development Domain. I will list down some of the key advantages of learning Javascript.Javascript is the most popular programming language in the world and that makes it a programmer’s great choice. Once you learnt Javascript, it helps you developing great front-end as well as back-end softwares using different Javascript based frameworks like jQuery, Node.JS etc.",
    authorName: 'Amit',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 01, 2022',
    cover: '/assets/images/designer-1.png',
  },
  {
    id: 2,
    title: 'Python',
    category: 'Python',
    subCategory: ['vacation', 'holidays', 'sight seeing'],
    description:
      "Python is a high-level, interpreted, interactive and object-oriented scripting language. Python is designed to be highly readable. It uses English keywords frequently where as other languages use punctuation, and it has fewer syntactical constructions than other languages.Python is Interpreted − Python is processed at runtime by the interpreter. You do not need to compile your program before executing it. This is similar to PERL and PHP.Python is Interactive − You can actually sit at a Python prompt and interact with the interpreter directly to write your programs.Python is Object-Oriented − Python supports Object-Oriented style or technique of programming that encapsulates code within objects.Python is a Beginner's Language − Python is a great language for the beginner-level programmers and supports the development of a wide range of applications from simple text processing to WWW browsers to games.",
    authorName: 'Nandu bede',
    authorAvatar: '/assets/images/nandu.jpg',
    createdAt: 'June 04, 2022',
    cover: '/assets/images/f67396fc3cfce63a28e07ebb35d974ac.webp',
  },
  {
    id: 3,
    title: 'Java',
    category: 'Java',
    subCategory: ['e-commerce store', 'clothing', 'shopping store'],
    description:
      "Java is a programming language and a platform. Java is a high level, robust, object-oriented and secure programming language.Java was developed by Sun Microsystems (which is now the subsidiary of Oracle) in the year 1995. James Gosling is known as the father of Java. Before Java, its name was Oak. Since Oak was already a registered company, so James Gosling and his team changed the name from Oak to Java.Platform: Any hardware or software environment in which a program runs, is known as a platform. Since Java has a runtime environment (JRE) and API, it is called a platform.",
    authorName: 'Sumit',
    authorAvatar: '/assets/images/sumit.webp',
    createdAt: 'June 05, 2022',
    cover: '/assets/images/fQwuyKJ9qxjSbr6REcgtmW-1200-80.webp',
  },
  {
    id: 4,
    title: 'C Language',
    category: 'CLanguage',
    subCategory: ['adrenaline', 'stay-fit', 'lifestyle'],
    description:
      "C is a procedural programming language. It was initially developed by Dennis Ritchie in the year 1972. It was mainly developed as a system programming language to write an operating system. The main features of the C language include low-level memory access, a simple set of keywords, and a clean style, these features make C language suitable for system programmings like an operating system or compiler development.",
    authorName: 'Shubham',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 06, 2022',
    cover: '/assets/images/cp.jpg',
  },
  {
    id: 5,
    title: 'PHP',
    category: 'PHP',
    subCategory: ['bbq', 'food', 'lifestyle'],
    description:
      "PHP started out as a small open source project that evolved as more and more people found out how useful it was. Rasmus Lerdorf unleashed the first version of PHP way back in 1994.PHP is a MUST for students and working professionals to become a great Software Engineer specially when they are working in Web Development Domain. I will list down some of the key advantages of learning PHP",
    authorName: 'Altaf',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 07, 2022',
    cover: '/assets/images/php.png',
  },
  {
    id: 6,
    title: 'CSS',
    category: 'CSS',
    subCategory: ['beaches', 'sea', 'holidays'],
    description:
      "Cascading Style Sheets, fondly referred to as CSS, is a simple design language intended to simplify the process of making web pages presentable.CSS is a MUST for students and working professionals to become a great Software Engineer specially when they are working in Web Development Domain. I will list down some of the key advantages of learning CSS",
    authorName: 'Sourav',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 08, 2022',
    cover:
      '/assets/images/css.png',
  },
  {
    id: 7,
    title: 'React js',
    category: 'React js',
    subCategory: ['skill', 'design', 'passion'],
    description:
      "ReactJS tutorial provides basic and advanced concepts of ReactJS. Currently, ReactJS is one of the most popular JavaScript front-end libraries which has a strong foundation and a large community.ReactJS is a declarative, efficient, and flexible JavaScript library for building reusable UI components. It is an open-source, component-based front end library which is responsible only for the view layer of the application. It was initially developed and maintained by Facebook and later used in its products like WhatsApp & Instagram.",
    authorName: 'Hritik',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 09, 2022',
    cover: '/assets/images/reactjs.png',
  },
  {
    id: 8,
    title: 'CPP',
    category: 'CPP',
    subCategory: ['beaches', 'sea', 'holidays'],
    description:
      "C++ is a middle-level programming language developed by Bjarne Stroustrup starting in 1979 at Bell Labs. C++ runs on a variety of platforms, such as Windows, Mac OS, and the various versions of UNIX. This C++ tutorial adopts a simple and practical approach to describe the concepts of C++ for beginners to advanded software engineers",
    authorName: 'Baisla',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 10, 2022',
    cover:
      '/assets/images/cpp.jpg',
  },
  {
    id: 9,
    title: 'Ruby',
    category: 'Ruby',
    subCategory: ['beaches', 'sea', 'holidays'],
    description:
      "Ruby is a dynamic, reflective, object-oriented, general-purpose programming language. Ruby is a pure Object-Oriented language developed by Yukihiro Matsumoto. Everything in Ruby is an object except the blocks but there are replacements too for it i.e procs and lambda. The objective of Ruby’s development was to make it act as a sensible buffer between human programmers and the underlying computing machinery.",
    authorName: 'sahil',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 11, 2022',
    cover:
      '/assets/images/ruby.png',
  },
  {
    id: 10,
    title: 'SQL',
    category: 'SQL',
    subCategory: ['beaches', 'sea', 'holidays'],
    description:
      "SQL tutorial provides basic and advanced concepts of SQL. Our SQL tutorial is designed for both beginners and professionals.SQL (Structured Query Language) is used to perform operations on the records stored in the database, such as updating records, inserting records, deleting records, creating and modifying database tables, views, etc.SQL is not a database system, but it is a query language.",
    authorName: 'Manish',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 12, 2022',
    cover:
      '/assets/images/sql.png',
  },
  {
    id: 11,
    title: 'Objective-C',
    category: 'Objective-c',
    subCategory: ['beaches', 'sea', 'holidays'],
    description:
      "Objective-C is a general-purpose, object-oriented programming language that adds Smalltalk-style messaging to the C programming language. This is the main programming language used by Apple for the OS X and iOS operating systems and their respective APIs, Cocoa and Cocoa Touch. This reference will take you through simple and practical approach while learning Objective-C Programming language.",
    authorName: 'Sunil',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 13, 2022',
    cover:
      '/assets/images/objc.png',
  },
  {
    id: 12,
    title: 'HTML',
    category: 'HTML',
    subCategory: ['beaches', 'sea', 'holidays'],
    description:
      "HTML stands for Hyper Text Markup Language, which is the most widely used language on Web to develop web pages. HTML was created by Berners-Lee in late 1991 but.HTML was the first standard HTML specification which was published in 1995. HTML 4.01 was a major version of HTML and it was published in late 1999. Though HTML 4.01 version is widely used but currently we are having HTML-5 version which is an extension to HTML 4.01, and this version was published in 2012.",
    authorName: 'Rohit',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 14, 2022',
    cover:
      '/assets/images/html.jpg',
  },
];
